/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.small[_nghost-%COMP%]   button[_ngcontent-%COMP%], .small   [_nghost-%COMP%]   button[_ngcontent-%COMP%]{padding:0!important}.role[_ngcontent-%COMP%]{font-size:13px;text-align:right}button.menutrigger[_ngcontent-%COMP%]{float:right}.nobottommargin[_ngcontent-%COMP%]{margin-bottom:0}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/userinfo/userinfo.component.css.shim.ngstyle.js.pre-build-optimizer.js